




















































/* General */
import Vue from 'vue'
import {
  ContentPlaceholders,
  ContentPlaceholdersText,
} from 'vue-content-placeholders'

/* Mixins */

/* Components */

/* Helpers */
import RouteAssistant from '@/helpers/route-assistant'
import ColorAssistant from '@/helpers/color-assistant'

/* Data types */
import { EEntities } from '@/types'
import { IAttachment } from '@/types/data-objects/attachments'
/* API */

export default Vue.extend({
  name: 'TaskDetailMetaOptions',

  components: {
    ContentPlaceholders,
    ContentPlaceholdersText,
  },

  props: {
    globalAttachments: {
      type: Array as () => IAttachment[],
      required: true,
    },

    showHarvestOption: {
      type: Boolean,
      required: true,
    },

    isPinned: {
      type: Boolean,
      required: true,
    },
  },

  data() {
    return {
      EEntities,
      ColorAssistant,
      RouteAssistant,
      showMoreOptions: false,
    }
  },

  computed: {
    hasGlobalAttachments(): boolean {
      return this.globalAttachments.length > 0
    },
    pinLabel(): string {
      return this.isPinned ? 'Unpin from dashboard' : 'Pin to dashboard'
    },
  },

  methods: {
    togglePin() {
      this.$emit('pin-toggled')
      this.closeMoreOptions()
    },
    closeMoreOptions() {
      this.showMoreOptions = true
      this.$nextTick(() => {
        this.showMoreOptions = false
      })
    },
  },
})
